/**
 * Types of order attachments
 */
export var OrderAttachmentType;
(function (OrderAttachmentType) {
    /**
     * Attachments uploaded as proof of eligibility for a cost waiver
     */
    OrderAttachmentType["CostWaiverDocument"] = "cost waiver document";
    /**
     * Attachments uploaded as supporting documents
     */
    OrderAttachmentType["SupportingDocument"] = "supporting document";
})(OrderAttachmentType || (OrderAttachmentType = {}));
